module.exports = "/_next/static/images/card-virtual-01-26d0e7d03a0397f8442cda305cbd362d.svg";